export const DATA_AUTOFIT_EXCLUDE = "data-autofit-exclude";

/**
 * Hide direct children that overflow the container's right edge (minus offset).
 * Skips children with `data-autofit-exclude`. Mutates classes in reverse order
 * so `order-last` does not skew subsequent measurements.
 */
export function autoFitHorizontalNodes(
  node: HTMLElement,
  autofitOffset = 0
): number {
  let overflowCount = 0;

  if (!node) {
    return 0;
  }

  const parentRect = node.getBoundingClientRect();

  if (parentRect.width === 0) {
    return 0;
  }

  const children = Array.from(node.children).filter(
    (child): child is HTMLElement =>
      child instanceof HTMLElement && !child.hasAttribute(DATA_AUTOFIT_EXCLUDE)
  );

  // Apply order-last in reverse so moving a child does not shift the next measurement
  children.reverse().forEach((child) => {
    const childRect = child.getBoundingClientRect();
    const overflow = childRect.right + autofitOffset - parentRect.right;

    if (overflow > 0) {
      // invisible keeps the node measurable
      child.classList.add("invisible", "order-last");
      overflowCount++;
    } else {
      child.classList.remove("invisible", "order-last");
    }
  });

  return overflowCount;
}
